<section class="greeting">
  <div class="main-container">
    <div class="greet-container">
      @if (selectedCapmaign === FLU_CAMPAIGN_ID) {
        <p class="greeting__title">{{ fluHeader?.title || 'Employee flu shot verification' }}</p>
      }
      @if (selectedCapmaign === COVID_CAMPAIGN_ID) {
        <p class="greeting__title">{{ covidHeader?.title || 'COVID-19 Vaccination' }}</p>
      }
    </div>
  </div>
</section>
<div class="assessment-wrapper">
  <div class="content">
    <main id="mainAssessments">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
